import type { MfgPricingResult } from "@/lib/mfg-boms";

const money = (n: number) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n);

export function MfgPriceFooter({ result, pending }: { result: MfgPricingResult | null; pending: boolean }) {
  return (
    <div className="flex items-center gap-4 border-t pt-3 text-sm">
      {pending && <span className="text-muted-foreground">Pricing…</span>}
      {result && !pending && (
        <>
          <span className="font-semibold text-green-600">Unit {money(result.unitPrice)}</span>
          <span className="font-semibold">Line {money(result.totalPrice)}</span>
          {result.profitWarning && <span className="text-amber-600">⚠ low profit</span>}
        </>
      )}
    </div>
  );
}
